import { useLingui } from "@lingui/react/macro";
import { Text } from "@offstreetparking/design-system/typography";
import { classNames } from "@offstreetparking/design-system/utils";
type StartTimeOptionsProps = {
	isStartTimeSetToNow: boolean;
	onNowClicked: () => void;
	onPickTimeClicked: () => void;
};
export const StartTimeOptions = ({ isStartTimeSetToNow, onNowClicked, onPickTimeClicked }: StartTimeOptionsProps) => {
	const { t } = useLingui();
	return (
		<div className="mb-2 flex w-full items-center gap-4 rounded-md bg-neutral-faded p-2">
			<button
				type="button"
				onClick={onNowClicked}
				className={classNames(
					"w-full rounded-md border border-neutral bg-white px-3 py-1.5",
					isStartTimeSetToNow ? "border-primary bg-primary/10 ring-2 ring-primary ring-offset-[-1px]" : "",
				)}
			>
				<Text size="sm">{t`Now`}</Text>
			</button>

			<button
				type="button"
				className={classNames(
					"w-full rounded-md border border-neutral bg-white px-3 py-1.5",
					!isStartTimeSetToNow ? "border-primary bg-primary/10 ring-2 ring-primary ring-offset-[-1px]" : "",
				)}
				onClick={onPickTimeClicked}
			>
				<Text size="sm">{t`Pick Time`}</Text>
			</button>
		</div>
	);
};
